interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Figma "Data" nav-tab icon (rounded table card). */
const FigmaDataIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 120 120'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 35C0 21.215 11.215 10 25 10H95C108.785 10 120 21.215 120 35H0ZM55 45H0V70H55V45ZM120 45H65V70H120V45ZM55 80H0V85C0 98.785 11.215 110 25 110H55V80ZM65 80V110H95C108.785 110 120 98.785 120 85V80H65Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaDataIcon;
